<template>
  <div class="table-responsive m-t-40" style="clear: both">
    <template v-if="!isMobile">
      <div class="col-md-12 col-sm-12"></div>
      <table class="table table-hover table-striped table-bordered">
        <thead class="table-info">
          <tr>
            <th class="text-center">No</th>
            <th v-for="(header, index) in header" :key="index">
              {{ header.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <template>
            <tr v-for="(value, indexOf) in items" :key="indexOf">
              <td class="text-center">
                {{ indexOf + 1 }}
              </td>

              <td
                v-for="(header, index) in header"
                :key="index"
                data-toogle="tooltip"
                :title="value[header.tooltip]"
              >
                <div>
                  <div
                    :style="fontStyle"
                    v-bind:class="{ 'bold-td': value.isBold }"
                  >
                    <div>
                      <span v-if="header.label == 'Approval Utama' && value.actor==2">
                        <span v-if="value.users_id == null">
                          <div class="col-md-12">
                            <CustomMulti
                              :query="personal"
                              :list="personalList"
                              label=""
                              :model="form.mainPersonal[indexOf]"
                              @data="setValue('mainPersonal', $event, value.id)"
                            />
                          </div>
                        </span>
                        <span v-else> </span>
                      </span>
                      <span v-if="header.label == 'Approval Utama' && value.actor==1">
                        <span v-if="value.users_id == null">
                          <div class="col-md-12">
                            <CustomMulti
                              :query="personalParaf"
                              :list="personalParafList"
                              label=""
                              :model="form.mainPersonal[indexOf]"
                              @data="setValue('mainPersonal', $event, value.id)"
                            />
                          </div>
                        </span>
                        <span v-else> </span>
                      </span>


                      <span v-if="header.label == 'Approval Pengganti' && value.actor==2">
                        <span v-if="value.alt_users_id == null && value.action == '0'">
                          <div class="col-md-12">
                            <CustomMulti
                              :query="personal"
                              :list="personalList"
                              label=""
                              :model="form.personal[indexOf]"
                              @data="setValue('personal', $event, value.id)"
                            />
                          </div>
                        </span>
                        <span v-else> </span>
                      </span>
                      <span v-if="header.label == 'Approval Pengganti' && value.actor==1">
                        <span v-if="value.alt_users_id == null && value.action == '0'">
                          <div class="col-md-12">
                            <CustomMulti
                              :query="personalParaf"
                              :list="personalParafList"
                              label=""
                              :model="form.personal[indexOf]"
                              @data="setValue('personal', $event, value.id)"
                            />
                          </div>
                        </span>
                        <span v-else> </span>
                      </span>

                      <span v-html="value[index]"> </span>
                    </div>
                  </div>
                </div>
              </td>
            </tr>

            <tr v-if="items.length === 0">
              <td :colspan="Object.keys(header).length + 2" class="text-center">
                No record found
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="action">
          Simpan
        </button>
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="close"
        >
          Batal
        </button>
      </div>
    </template>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: {
    header: {
      required: true,
      type: Object,
    },
    items: {
      required: true,
      type: Array,
    },
    draftingFileDetail: {
      required: false,
      type: Object,
    },
  },
  data() {
    let stl = { fontWeight: 600 };
    return {
      fontStyle: stl,
      form: {
        mainPersonal: {},
        personal: {},
      },
      personalList: [],
      personalParafList: [],
    };
  },
  watch: {
    draftingFileDetail: function() {
      this.fillEditData();
    },
  },
  mounted() {
    this.personal("");
    this.personalParaf("");
  },
  methods: {
    commitState(state) {
      this.$store.commit("drafting_file/STATE", state);
    },
    close() {
      this.$emit("close");
    },
    personal(query) {
      axios.get(`users/active?same_unit=1&up_one_level=1&is_signer=1&s=${query}`).then((res) => {
        this.personalList = res.data.items;
      });
    },
    personalParaf(query) {
      axios.get(`users/active?same_unit=1&s=${query}`).then((res) => {
        this.personalParafList = res.data.items;
      });
    },
    async action() {
      const data1 = Object.entries(this.form.personal)
        .map(([docId, personal]) => {
          if (personal) {
            return {
              id: Number(docId),
              alt_user: personal && personal.value,
            };
          }
        })
        .filter(Boolean);

      const data2 = Object.entries(this.form.mainPersonal)
        .map(([id, mainPersonal]) => {
          if (mainPersonal) {
            return {
              id: Number(id),
              user: mainPersonal && mainPersonal.value,
            };
          }
        })
        .filter(Boolean);

      Array.prototype.push.apply(data1,data2); 

      const data = {
        doc_id: this.draftingFileDetail.id,
        signers: data1,
      };

      try {
        await axios.post(`drafting-file/updateApproval/bulk`, {
          data,
        });
        this.notifSuccess({
          title: "Success",
          text: "Data berhasil di simpan",
        });
      } catch {
        this.notifError({
          title: "Error",
          text: "Gagal update data",
        });
      } finally {
        this.close();
        this.form.personal = {};
        this.form.mainPersonal = {};
      }
    },
    setValue(model, data, id) {
      this.form[model][id] = data;
    },
    fillEditData() {
      let form = this.form;
      const dataApproval = this.draftingFileDetail.signers;
      const dataApproval2 = this.draftingFileDetail.approvals;
      if (!dataApproval) {
        return [];
      }
      dataApproval.map((item, key) => {
        const altUserFind = dataApproval2.find(
          (id) => id.id == item.pivot.alt_users_id
        );
        if (altUserFind) {
          form.personal[key] = {
            value: altUserFind.id,
            text: altUserFind.name,
          };
        } 
      });
    },
  },
  async init() {
    this.personal("");
    this.personalParaf("");
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
};
</script>
<style>
.tooltip-inner {
  max-width: 200px;
  padding: 3px 8px;
  color: #fff;
  text-align: center;
  background-color: #31708f;
  border-radius: 0.25rem;
}
</style>

<style>
.bold-td {
  font-weight: 600;
}
</style>